var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ll-list-with-button title"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"title time"},[_vm._v(" "+_vm._s(_vm.time)+" ")]),(_vm.avatar)?_c('div',{staticClass:"title time ll-avatar"},[_vm._v(" "+_vm._s(_vm.avatar)+" ")]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }